import Avatar from './avatar';
export * from './avatar';
export default Avatar;